import { useBrandAndTheme } from 'components/helpers/ContextProvider/BrandAndThemeContext';
import { HeroDecor as HeroBettyCrocker } from './HeroDecor.brand.bettycrocker';
import { HeroDecor as HeroPillsbury } from './HeroDecor.brand.pillsbury';
import { HeroDecor as HeroDefault } from './HeroDecor.brand.default';
import { HeroDecor as HeroWhiteLabel } from './HeroDecor.brand.whitelabel';

export const HeroDecor = () => {
  const { brand } = useBrandAndTheme();

  switch (brand) {
    case 'BrandsBettyCrocker':
      return <HeroBettyCrocker />;
    case 'BrandsPillsbury':
      return <HeroPillsbury />;
    case 'BrandsWhiteLabel':
      return <HeroWhiteLabel />;
    default:
      return <HeroDefault />;
  }
};
